/**
 * Returns the most recently marked measure, this will be the last entry in the results.
 * @param measureName - string that identifies the measure name from the performance entries
 */
export function getLastMarkedMeasure(measureName: string): PerformanceEntry | null {
    let lastMarkedMeasure: PerformanceEntry;
    try {
        // Fetch the measure
        const results = performance.getEntriesByName(measureName);
        if (results?.length > 0) {
            // The measure will have been added in the last position of the array, so return the last entry from results
            lastMarkedMeasure = results.slice(-1)[0];
        }
    } catch (e) {
        return null;
    }
    return lastMarkedMeasure;
}
